import FullWidthLayout from "@/layouts/FullWidthLayout";
import KCustomersTable from "kinnect-front/KCustomers/KCustomersTable";
import { Customer } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "CustomersPage",

	metaInfo: { title: "Customers" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		customers: [],
		search: ""
	} ),

	computed: {
		numCustomers() {
			return this.customers.length;
		},

		toolbarActions() {
			if ( this.$can( "add_customers" ) ) {
				return {
					icon: "add_circle",
					text: "Add Customer",
					to: { name: "customerAdd" },
					tooltip: "Add a new customer"
				};
			}
		}
	},

	watch: {
		numCustomers( numCustomers ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numCustomers} customers` );
		}
	},

	methods: {
		async fetchCustomers() {
			this.customers = await Customer.get();
		},

		async fetch() {
			await this.fetchCustomers();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KCustomersTable
					items={this.customers}
					loading={this.$wait.is( "get customers" )}
					search={this.search}
				></KCustomersTable>
			</VCard>
		</FullWidthLayout>;
	}
};
